import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VehicleLookupRepository } from '../../../domain/repositories/vehicle-lookup/vehicle-lookup.repository';
import {
  UpdateOwnerPayerInput,
  VehicleLookupResult,
} from '../../../domain/interfaces/vehicle-lookup/vehicle-lookup.interface';

@Injectable({
  providedIn: 'root',
})
export class UpdateOwnerPayerUseCase {
  private readonly vehicleLookupRepository = inject(VehicleLookupRepository);

  execute(input: UpdateOwnerPayerInput): Observable<VehicleLookupResult> {
    return this.vehicleLookupRepository.updateOwnerAndPayer(input);
  }
}
